module.exports = __webpack_public_path__ + "static/media/icon-transportation.a88c5350.png";